import styled from "styled-components";

export const BulletText = styled.div.attrs({
  className: "bullet",
})<{ color: string }>`
  &:before {
    background-color: ${({ color }) => color};
  }
`;
